<ng-container *ngIf="loading">
  <div class="loading-bar">
      <tm1-progress-ring value="" min="0" max="1" size="regular" ></tm1-progress-ring>
</div>
</ng-container>


<div class="topborderButton">
    <tm1-button routerLink="/tools/barcodehistory"> Barcode History </tm1-button>
    <tm1-button routerLink="/tools/gates">Gate Set Up</tm1-button>
    <tm1-button routerLink="/tools/scanner">Scanner</tm1-button>
</div>

<div class="container">
    <div class="card-container">
        <br/>
      <tm1-card variant = "shadow">
            <legend>
              Gates Config
              <tm1-icon-tooltip icon="info" size="small" color="blue">
                Gate Names must match <b>exactly</b> what is built in Entry
              </tm1-icon-tooltip>
            </legend>

            <tm1-label>Venue</tm1-label>
            <select ngDefaultControl class="form-control" [(ngModel)]="Selectedvenue" (change) = "onVenueChange()">
                <option value="">Please Select a Venue</option>
                <option *ngFor="let venue of venuelist" [value]="venue.key">
                  {{ venue.value.name }}
                </option>
              </select>
              <br/>
              <div  class="centered-container">
                <div>
                  <tm1-button (click) = "addGate()">
                    Add Gate
                  </tm1-button>
                </div>
                </div>
      </tm1-card>

      <div>
        <tm1-card>
          <tm1-data-grid generate-header="" focus-column-index="0" focus-row-index="0">
            <tm1-data-grid-row row-type="sticky-header">
              <tm1-data-grid-cell grid-column="1" cell-type="columnheader">
                Gate Name
              </tm1-data-grid-cell>
              <tm1-data-grid-cell grid-column="2" cell-type="columnheader">
                Config
              </tm1-data-grid-cell>
            </tm1-data-grid-row>
            <tm1-data-grid-row>
              <ng-container *ngFor="let data of gatesArray">
                <tm1-data-grid-cell grid-column="1">
                  {{ data.value }}
                </tm1-data-grid-cell>
                <tm1-data-grid-cell grid-column="2">
                  <tm1-icon size="small" color="" icon="edit" type=""
                  (click)="selectEditGateClick($event, data)">
                  </tm1-icon>
                  <tm1-icon size="small" color="" icon="delete" type=""
                    (click)="selectDeleteGateClick($event, data)">
                  </tm1-icon>
                </tm1-data-grid-cell>
              </ng-container>
            </tm1-data-grid-row>
          </tm1-data-grid>
        </tm1-card>
      </div>
    </div>
    </div>

